
<div class="_dialog-title">
	<div class="order-ticket-diner mr-2">
		<div class="order-ticket-diner-icon" [style.background]="data.background">
			{{ data.initials }}
		</div>
	</div>
	<div class="flex-grow-1">{{data.name}}</div>
	<button mat-icon-button mat-dialog-close color="accent">
		<mat-icon>close</mat-icon>
	</button>
</div>




<div class="_dialog-content" style="min-height: 170px; min-width: 80vw; max-height: calc(100vh - 150px);">
	<table class="table">
		<tr>
			<th class="w-100">{{'TO.total-items' | translate}}</th>
			<th class="no-wrap">{{data.totalItems | lamount}}</th>
		</tr>
		<tr><td colspan="2"><hr style="margin: 0.7rem 0"/></td></tr>
		@for (offer of data.offers; track offer ) {
		<tr>
			<td class="w-100">{{offer.name}}</td>
			<td class="no-wrap">{{offer.amount | lamount}}</td>
		</tr>
		}
	</table>
</div>

<div class="_bottom-actions border-top" *ngIf="data.$$balanceDue">

	<button mat-raised-button color="accent" class="lg main-continue-btn mt-2" type="button" (click)="apply('partial')" style="min-width:240px">
		<div class="_inner" style="justify-content:center">
			<div>{{'pay' | translate}}</div>
		</div>
	</button>

</div>
